<div fxLayout="row" fxLayoutAlign="start center">
  <button mat-button routerLink="/login">
    <mat-icon>account_circle</mat-icon>
    Log In
  </button>
  <button fxHide fxShow.gt-xs mat-button routerLink="/signup">
    <mat-icon>assignment</mat-icon>
    Register
  </button>
</div>
